import React from "react"
import PropTypes from "prop-types"
import { ResponsiveBar } from '@nivo/bar'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

export default function VerticalBarChart(props) {
  const breakpoints = useBreakpoint();
  const chartData = []

  function trunctateString(string) {
    const length = breakpoints.sm ? 13 : breakpoints.md ? 25 : 20
    return (string.length > length) ? string.substr(0, length-1) + '...' : string
  }

  props.xmlChildren.map(child => chartData.push({id: trunctateString(child.content), value: Number(child.attributes.total)}))

  // Add up all values to get total
  const total = chartData.map(datum => datum.value).reduce((total, current) => total + current, 0)

  const legendSettings = [{
    dataFrom: 'indexes',
    anchor: 'bottom-right',
    direction: 'column',
    justify: false,
    translateX: 120,
    translateY: 0,
    itemsSpacing: 2,
    itemWidth: 100,
    itemHeight: 20,
    itemDirection: 'left-to-right',
    itemOpacity: 0.85,
    symbolSize: 20,
    effects: [
      {
        on: 'hover',
        style: {
          itemOpacity: 1
        }
      }
    ]
  }]

  const fillSettings = [];

  for(let i = 0; i < chartData.length; i++ ){
    if(i % 4 === 0){
      fillSettings.push({
        match: {
          id: chartData[i].id
        },
        id: 'dots'
      })
    }
    else if ((i + 2) % 2 === 0 ){
      fillSettings.push({
        match: {
          id: chartData[i].id
        },
        id: 'lines'
      })
    }
  }

  let marginLeft = 40
  let marginRight = 60
  let marginBottom = 80
  let tickRotation = 0

  if (props.uses_legend){
    marginRight = 130
  }

  if (breakpoints.md) {
    marginRight = 10
    marginBottom = 130
    tickRotation = 45
  }

  if(breakpoints.sm) {
    tickRotation = 90
    marginBottom = 100
  }




  return (
    <ResponsiveBar
      data={chartData}
      margin={{ top: 50, right: marginRight, bottom: marginBottom, left: marginLeft }}
      padding={0.3}
      // colors={props.custom_scheme}
      colors={{ scheme: 'paired' }}
      colorBy='value'
      defs={[
        {
          id: 'dots',
          type: 'patternDots',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          size: 4,
          padding: 1,
          stagger: true
        },
        {
          id: 'lines',
          type: 'patternLines',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          rotation: -45,
          lineWidth: 6,
          spacing: 10
        }
      ]}
      fill={fillSettings}
      borderColor={{ from: 'color' }}
      axisTop={null}
      axisRight={null}
      axisBottom={ {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: tickRotation,
        legend: breakpoints.md ? null : props.question,
        legendPosition: 'middle',
        legendOffset: 60
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: '',
        legendPosition: 'middle',
        legendOffset: -40
      }}
      tooltip={d => (d.id, d.value, `Responses: ${d.value}`)}
      label={d => `${Math.round((d.value / total) * 100)}%`}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor='#ffffff'
      legends={props.uses_legend ? legendSettings : []}
      animate={false}
      motionStiffness={90}
      motionDamping={15}

    />
  )
}

VerticalBarChart.propTypes = {
  xmlChildren: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  uses_legend: PropTypes.bool.isRequired,
  custom_scheme: PropTypes.array.isRequired,
}

VerticalBarChart.defaultProps = {
  xmlChildren: [],
  question: null,
  uses_legend: false
}
